import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  root: {
    flex: 1,
    backgroundColor: colors.backgroundPrimary,
  },
  desktopPad: {
    flex: 1,
    padding: theme.spacing[9],
  },
  mobilePad: {
    flex: 1,
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[6],
  },
  mobileBranding: {
    flex: 1,
  },
  mobileFooter: {
    paddingTop: theme.spacing[5],
  },
  desktopButton: {
    alignSelf: 'flex-start',
  },
}));
